import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import UserDropdown from './UserDropdown';  // Assuming this is your component for selecting users
import ExternalUserInput from "./ExternalUserInput";  // Assuming this handles input for external users
import "react-toastify/dist/ReactToastify.css";
import "./toaststyle.css";

const AddPublications = () => {
  const [fields, setFields] = useState({
    // ... your fields here
  });

  const [selectedCollegeUsers, setSelectedCollegeUsers] = useState([]);
  const [selectedOtherUsers, setSelectedOtherUsers] = useState([]);
  const [errors, setErrors] = useState({});

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };

  const handleSelectUser = (userName) => {
    setSelectedOtherUsers((prevUsers) => [...prevUsers, userName]);
  };

  const handleRemoveOtherUser = (userName) => {
    setSelectedOtherUsers(selectedOtherUsers.filter((user) => user !== userName));
  };
  const handleSelectCollegeUser = (user) => {
    setSelectedCollegeUsers([...selectedCollegeUsers, user]);
  };

  const handleRemoveCollegeUser = (userId) => {
    setSelectedCollegeUsers(selectedCollegeUsers.filter(user => user.value !== userId));
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      const publicationData = {
        ...fields,
        collegeCoauthors: selectedCollegeUsers.map((user) => ({ userId: user.value })),
        otherCoauthors: selectedOtherUsers,
      };
  
      console.log("Publication Data to be sent:", publicationData);
  
      // Send data to the backend
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/publications`, publicationData);
  
      toast.success("Publication created successfully!");
  
      // Reset fields and selected users
      setFields({
        publication: "",
        doi: "",
        title: "",
        journal: "",
        pubid: "",
        date: "",
        contribution: "",
        reach: "",
        editionno: "",
        volnum: "",
        pfrom: "",
        pto: "",
        isbn: "",
        issn: "",
        indexing: "",
        issuenum: "",
        impactfactor: "",
        claimedby: "",
      });
  
      setSelectedCollegeUsers([]);
      setSelectedOtherUsers([]);
      setErrors({});
    } catch (error) {
      console.error("Error creating publication:", error);
  
      if (error.response && error.response.status === 400 && error.response.data.includes("DOI already exists")) {
        toast.error("The DOI already exists. Please use a unique DOI.");
      } else {
        toast.error("Error creating publication. Please try again.");
      }
    }
  };
  

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-10 border rounded p-4 mt-2">
          <div className="box">
            <h2 className="text-center m-4">Publication</h2>

            

            
           

            <form onSubmit={handleOnSubmit}>
              {/* Existing form fields */}
              <div className="row mb-3">
                <div className="form-group col-md-4">
                  <label htmlFor="publication" className="form-label">
                    Publication Type<span className="text-danger">*</span>
                  </label>
                  <select
                    id="publication"
                    className="form-control"
                    name="publication"
                    value={fields.publication}
                    onChange={onInputChange}
                  >
                    <option value="">Select a publication type</option>
                    <option value="journal">Journal</option>
                    <option value="conference">Conference</option>
                    <option value="book">Book</option>
                  </select>
                </div>
                <div className="form-group col-md-8">
                  <label htmlFor="doi" className="form-label">
                    DOI/URL<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="doi"
                    className="form-control"
                    placeholder="http://"
                    name="doi"
                    value={fields.doi}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label htmlFor="title" className="form-label">
                    Title<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="title"
                    className="form-control"
                    placeholder="Paper Title"
                    name="title"
                    value={fields.title}
                    onChange={onInputChange}
                  />
                </div>

                {/* Journal Name Input */}
                <div className="form-group col-md-12">
                  <label htmlFor="journal" className="form-label">
                    Journal Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="journal"
                    className="form-control"
                    placeholder="Publication/Journal Name"
                    name="journal"
                    value={fields.journal}
                    onChange={onInputChange}
                  />
                </div>

                {/* Publisher Id Input */}
                <div className="form-group col-md-5">
                  <label htmlFor="claimed" className="form-label">
                   Claimend By<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="claimed"
                    className="form-control"
                    placeholder="Claimed by"
                    name="claimed"
                    value={fields.claimed}
                    onChange={onInputChange}
                  />
                </div>

                {/* Contribution Type Dropdown */}
                <div className="form-group col-md-4">
                  <label htmlFor="contribution" className="form-label">
                    Contribution Id<span className="text-danger">*</span>
                  </label>
                  <select
                    id="contribution"
                    className="form-control"
                    name="contribution"
                    value={fields.contribution}
                    onChange={onInputChange}
                  >
                    <option value="">Select a contribution type</option>
                    <option value="First Author">First Author</option>
                    <option value="Second Author">Second Author</option>
                    <option value="Third Author">Third Author</option>
                    <option value="Fourth Author">Fourth Author</option>
                    <option value="Other">Other</option>
                    <option value="Supervisor">Supervisor</option>
                  </select>
                </div>

                {/* Reach Type Dropdown */}
                <div className="form-group col-md-3">
                  <label htmlFor="reach" className="form-label">
                    Reach<span className="text-danger">*</span>
                  </label>
                  <select
                    id="reach"
                    className="form-control"
                    name="reach"
                    value={fields.reach}
                    onChange={onInputChange}
                  >
                    <option value="">Select a reach type</option>
                    <option value="international">International</option>
                    <option value="national">National</option>
                    <option value="regional">Regional</option>
                    <option value="institutional">Institutional</option>
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="volnum" className="form-label">
                    Volume Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="volnum"
                    className="form-control"
                    placeholder="Volume Number"
                    name="volnum"
                    value={fields.volnum}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="date" className="form-label">
                    Publication Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    name="date"
                    value={fields.date}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="pfrom" className="form-label">
                    Page From<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="pfrom"
                    className="form-control"
                    placeholder="From page"
                    name="pfrom"
                    value={fields.pfrom}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="pto" className="form-label">
                    Page To<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="pto"
                    className="form-control"
                    placeholder="From to"
                    name="pto"
                    value={fields.pto}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="issn" className="form-label">
                    ISSN<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="issn"
                    className="form-control"
                    placeholder="ISSN"
                    name="issn"
                    value={fields.issn}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="isbn" className="form-label">
                    ISBN<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="isbn"
                    className="form-control"
                    placeholder="ISBN"
                    name="isbn"
                    value={fields.isbn}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="indexing" className="form-label">
                    Indexing<span className="text-danger">*</span>
                  </label>
                  <select
                    id="indexing"
                    className="form-control"
                    name="indexing"
                    value={fields.indexing}
                    onChange={onInputChange}
                  >
                    <option value="">Select a indexing type</option>
                    <option value="sci">SCI</option>
                    <option value="scopus">SCOPUS</option>
                    <option value="ugc">UGC</option>
                    <option value="webofscience">Web ofScience</option>
                    <option value="others">Others</option>
                  </select>
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="issuenum" className="form-label">
                    Issue Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="issuenum"
                    className="form-control"
                    placeholder="Issue Number"
                    name="issuenum"
                    value={fields.issuenum}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="impactfactor" className="form-label">
                    Impact Factor<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="impactfactor"
                    className="form-control"
                    placeholder="Impact Factorr"
                    name="impactfactor"
                    value={fields.impactfactor}
                    onChange={onInputChange}
                  />
                </div>


                {/* Username Input */}
                <div className="form-group col-md-6">
                  <label htmlFor="editionno" className="form-label">
                    Edition number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="editionno"
                    className="form-control"
                    placeholder="Enter Endition no"
                    name="editionno"
                    value={fields.editionno}
                    onChange={onInputChange}
                  />
                </div>
                <div className="form-group col-md-6">
  <label htmlFor="userDropdown" className="form-label">
    Co-author from Sona<span className="text-danger">*</span>
  </label>
  <UserDropdown
    selectedUsers={selectedCollegeUsers}        // Pass the state for college co-authors
    setSelectedUsers={setSelectedCollegeUsers}   // Pass the state setter function for college co-authors
    handleSelectUser={handleSelectCollegeUser}   // Function to handle selecting users for college co-authors
    handleRemoveUser={handleRemoveCollegeUser}   // Function to handle removing users from the list
  />
</div>

<div className="form-group col-md-6">
  <label htmlFor="externalInput" className="form-label">
      Other Authors
  </label>
  <ExternalUserInput
  selectedUsers={selectedOtherUsers}
  setSelectedUsers={setSelectedOtherUsers}
  handleSelectUser={handleSelectUser}
  handleRemoveUser={handleRemoveOtherUser}
/>

</div>

                {/* More form fields here */}

                <button type="submit" className="btn btn-outline-primary mt-4">
                  Add Publication
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default AddPublications;
